<div class="pb-3 d-flex flex-md-row flex-column justify-content-center">
  <div>
    <a href="https://www.sothebysrealty.com/" target="_blank">sothebysrealty.com</a>
  </div>
  <div class="v-divider"></div>
  <div>
    <a href="https://access.sir.com/content/sir/en/helpdeskrequest.html" target="_blank">Help</a>
  </div>
</div>
